import { useSelector } from 'src/store/react';
import { selectResults, selectSearchExecuted } from 'src/store/selectors';

export const useSearchParams = () => {
  const results = useSelector(selectResults);
  const searchExecuted = useSelector(selectSearchExecuted);

  return results?.searchParams
    ? {
        ...results?.searchParams,
        ...(searchExecuted?.keywords
          ? { keywords: searchExecuted?.keywords }
          : {}),
      }
    : {};
};
